import PillarFormDateTimeInput from "shared/components/pillar-form/components/PillarFormDateTimeInput";
import PillarFormSelectMenu from "shared/components/pillar-form/components/PillarFormSelectMenu";
import PillarFormTextInput from "shared/components/pillar-form/components/PillarFormTextInput";

/**
 * The components a surveyjs-like config element can render as. Which one an
 * element maps to is decided by the `isDynamic*` predicates, not by this key -
 * definitions spell the type in their own vocabulary ("dropdown", "text" with
 * an `inputType` of "date", and so on).
 */
export const PillarFormDynamicInputComponentsMapper = {
  Text: PillarFormTextInput,
  DateTime: PillarFormDateTimeInput,
  Select: PillarFormSelectMenu,
} as const;
